import StoreModule from "../core/StoreModule";
import { TenantState } from "./state";

class TenantStore extends StoreModule<TenantState> {
  protected state = {};
}

export const $tenant = StoreModule.singleton(TenantStore);
